<form [formGroup]="targetForm">   
    <header class="info-tile-alt heading-row">
        <div class="title-container">
            <h2>Bulk Assign Surveys</h2>
        </div>
        <div class="drawer-close" (click)="rightSideDrawerService.closeRightSideDrawer()"><i class="fas fa-times" aria-hidden="true"></i></div>
    </header>
    <div class="select-sme-bulk-assign">
    <label class="sme-label">Select SME:</label>
    <div class="input-with-icon sme-search-dropdown">
        <input required class="sme-search-input search-box-custom"
               placeholder="Type to filter SME names"
               type="text"  
               name="focus"
               [resultTemplate]="rt"
               [kpmgUiTypeahead]="searchSMEStream"
               (click) = "searchSMEStream"
                (selectItem)="onSMEFilter($event)"               
                                                     
                [value]="smeSearch()" (blur)="enableAssign()"      
               >
               <button type="reset" class="cross-icon" (click)="clearSME()"></button> 
               <i class="fa-solid fa-search" aria-hidden="true"></i>
               <div class="alert alert-danger alert-bulk-assign" role="alert" *ngIf="noResults"><i class="fas fa-exclamation-triangle no-result"></i> No SME Found</div>
    </div>
    </div>

      
           <ng-template #rt let-r="result" let-t="term">
            <kpmg-ui-highlight [title]="r.userName" class="search-engagement__name" [result]="r.displayName" [term]="t"></kpmg-ui-highlight>&nbsp; 
                <!-- <kpmg-ui-highlight class="search-engagement__name" [result]="r.userName" [term]="t"></kpmg-ui-highlight>                                       -->
                
            </ng-template>

              <section class="sideRight-body">
                <div class="select-survey-block">
                    <label class="survey-label select-survey">Select Surveys:</label>
                    <table class="assign-surveys-checklist" cellpadding="5" cellspacing="5"> 
                        <tr class="select-all-chk"> 
                        <td>
                        <label class="datatable-checkbox parent-checkbox kpmg-checkbox">
                            <input type="checkbox" [checked]="selectAll"  (change)="SelectAll($event)"/><span></span>
                        </label>
                        </td>
                        </tr>          
                        <tr class="" *ngFor="let survey of unAssignedsurveys; let i = index" [attr.data-index]="i">        
                        <td>
                            <label class="datatable-checkbox child-checkbox kpmg-checkbox">
                            <input type="checkbox"  (change)="SetSurveys(survey,$event,i)"/><span>{{survey.surveyName}}</span>             
                            </label>
                        </td>
                        </tr>      
                    </table>
                </div>
        
                <div class="selected-survey-block">
                    <label class="survey-label">Selected Surveys:</label>
                    <div class="selected-box">
                        <div class="kpmg-checkbox" *ngFor="let survey of selectedSurveys; let i = index" [attr.data-index]="i">
                            <label class="datatable-checkbox kpmg-checkbox">
                                <input type="checkbox" [checked]="true"  (change)="UnSetSurveys(survey,$event,i)" /><span>{{survey.SurveyName}}</span>
                            </label>
                        </div>
                    </div>
               </div>
              </section>
        
              <footer class="endFormSubmit info-tile">
                  <button type='button' class="btn btn-success" (click)="AssignBulk()" [disabled]="isAddDisabled">Assign</button>
                  <button type='button' class="btn kpmg-button--flat" (click)="rightSideDrawerService.closeRightSideDrawer()">Cancel</button>
              </footer>   
        </form>
        